import { PrineConvertImportData } from './types/PrineConvertImportData';
import { PrineConvertAdapter } from './PrineConvertAdapter';
import { PrineConvert } from './PrineConvert';
import { PrineConvertAdapterImport } from './types/PrineConvertAdapterImport';

export class PrineConvertImport {
    private readonly data: PrineConvertImportData;

    constructor(data: PrineConvertImportData) {
        this.data = data;
    }

    public using(implementation: PrineConvertAdapter): PrineConvertAdapterImport[] {
        return implementation.import(PrineConvert.cloneData(this.data));
    }
}
